import React from 'react';
import { Modal, Input, Form, Select, Table, Empty, Tabs, Button, Tooltip } from 'antd';
import dialog from "../../../common/utility/dialog";

const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    idTipoCampo: values.idTipoCampo.key,
                    idTipoAtributo: this.props.formValues.activeKey === "1" ? 1 : 2,
                    items: this.props.formValues.isLista ? this.fetchReferencias(values) : null,

                }

                if (this.props.formValues.isLista) {
                    if (this.props.formValues.detalleItem.length === 0) {

                        dialog.warning("Por favor agregue lista detalle");
                        return false;
                    }
                }

                this.props.onSave(form, this.props.form);
            }
        });
    }

    fetchReferencias = (values) => {
        var result = [];
        var keys = [];
        var obj = Object.assign({}, values.arrNombre);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                id: 0,
                nombre: values.arrNombre[key]
            });
        });

        return JSON.stringify(result);
    };



    render() {

        var title = "";

        if (this.props.formValues.activeKey === "1")
            title = "Atributo";
        if (this.props.formValues.activeKey === "2")
            title = "Variante";


        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('isLista', { initialValue: this.props.formValues.isLista });

        return (
            <Modal
                title={
                    this.props.formValues.id === 0 ? `Registrar ${title}` : `Modificar ${title}`
                }
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-12 form-group">
                            <Form.Item label="Tipo de Campo">
                                {getFieldDecorator('idTipoCampo', {
                                    initialValue: this.props.formValues.idTipoCampo ?
                                        { key: this.props.formValues.idTipoCampo } : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obligatorio.",
                                        },
                                    ],
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo Campo"}
                                        optionFilterProp="children"
                                        disabled={this.props.form.getFieldValue("isLista") && this.props.formValues.activeKey === "2" }
                                        onChange={(option, item) => {
                                            this.props.onChange(item.props.codigo, option.key, this.props.form);
                                        }}
                                    >
                                        {this.props.formValues.tipoCampos.map(item => (
                                            <Option key={item.id} value={item.id} codigo={item.abreviatura}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        {this.props.form.getFieldValue("isLista") ?

                            <div className="col-md-12 form-group">
                                <Tabs
                                    tabBarExtraContent={
                                        <div className="custom-options">
                                            <Button
                                                icon="plus"
                                                type="primary"
                                                onClick={() =>
                                                    this.props.onAgregarDetalle(
                                                        this.props.form.setFieldsValue,
                                                        this.props.form.getFieldValue
                                                    )
                                                }
                                            >
                                                Agregar
                                            </Button>
                                        </div>
                                    }
                                >
                                    <TabPane tab="Opciones" key="1">
                                        <Table
                                            className={'table-referencia'}
                                            scroll={{ x: true }}
                                            size="small"
                                            style={{ overflowX: 'auto' }}
                                            pagination={false}
                                            dataSource={this.props.formValues.detalleItem}
                                            rowKey={record => record.identifier}
                                            locale={{
                                                emptyText: <Empty
                                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                    description='Pulse el botón "+ Agregar".'
                                                />
                                            }}
                                            columns={[
                                                {
                                                    key: 'remove-button',
                                                    align: 'center',
                                                    width: 40,
                                                    fixed: 'left',
                                                    render: (value, row) => (
                                                        <span>
                                                            <div className="custom-options">
                                                                <Tooltip placement="top" title="Remover">
                                                                    <Button
                                                                        type="danger"
                                                                        icon="delete"
                                                                        size={"small"}
                                                                        onClick={() => this.props.onRemove(row)}
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </span>
                                                    )
                                                },
                                                {
                                                    title: 'Nombre',
                                                    dataIndex: 'nombre',
                                                    key: 'nombre',
                                                    align: 'center',
                                                    width: 350,
                                                    render: (value, row) => {
                                                        return (
                                                            <Form.Item>
                                                                {getFieldDecorator(`arrNombre[${row.identifier}]`, {
                                                                    initialValue: value,
                                                                    rules: [{
                                                                        required: true,
                                                                        message: "Obligatorio"
                                                                    }]
                                                                })(
                                                                    <Input
                                                                        placeholder="Opcion"
                                                                        autoComplete="off"
                                                                        className="text-left"
                                                                    />
                                                                )}
                                                            </Form.Item>
                                                        );
                                                    }
                                                },

                                            ]}
                                        />
                                    </TabPane>
                                </Tabs>
                            </div>

                            : null
                        }

                    </div>

                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)